import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { dateFormatterPlugin } from './plugins/dateFormatterPlugin';
import { auth0 } from './plugins/auth0';
import { vMaska } from 'maska/vue';

import App from './App.vue';
import router from './router/router';

import LivUi from '@ss/liv-ui';
import SsUiLib from '@ss/ss-ui-lib';

import { numberOnlyDirective } from '@/directives/index';

import * as icons from '@/common/icons';

import vueGtag from 'vue-gtag';
import { decimalOnlyDirective, negativeDecimalOnlyDirective } from './components/functions/validation';
import { clickOutsideDirective } from './directives/click-outside';
import { vLiviMask } from '@/common/masks/liviMasks';

const app = createApp(App);

app.use(router);
app.use(auth0);
app.use(
  vueGtag,
  {
    config: {
      id: import.meta.env.VITE_GTAG_ID,
    },
  },
  router
);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(pinia);
app.use(dateFormatterPlugin);
app.use(SsUiLib);
app.use(LivUi);
app.directive('num-only', numberOnlyDirective);
app.directive('decimal-only', decimalOnlyDirective);
app.directive('negative-decimal', negativeDecimalOnlyDirective);
app.directive('click-outside', clickOutsideDirective);
app.directive('maska', vMaska);

app.directive('livi-mask', vLiviMask);

Object.entries(icons).forEach(([iconName, iconComponent]) => {
  app.component(iconName, iconComponent);
});

router.isReady().then(() => {
  // Waiting for the router to be ready prevents race conditions when returning from a loginRedirect or acquireTokenRedirect
  app.mount('#app');
});
